import React, { useEffect, useState } from "react";
import Sidebar from "../components/Sidebar";
import Navbar from "../components/Navbar";
import axiosInstance from "../../axiosInstance";
import toast from "react-hot-toast";

const LoginDevices = () => {
  const [devices, setDevices] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchDevices = async () => {
    try {
      setLoading(true);
      const { data } = await axiosInstance.get("/admin/login-devices");
      setDevices(data.devices || []);
    } catch (error) {
      toast.error(error.response?.data?.message || "Error fetching login devices");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchDevices();
  }, []);

  const removeDevice = async (device) => {
    try {
      await axiosInstance.delete(`/admin/login-devices/${device.adminId}/${device._id}`);
      toast.success("Device logged out successfully");
      fetchDevices();
    } catch (error) {
      toast.error(error.response?.data?.message || "Error removing device");
    }
  };

  const formatDate = (dateString) => {
    if (!dateString) {
      return "-";
    }

    return new Date(dateString).toLocaleString("en-IN", {
      day: "2-digit",
      month: "short",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  };

  return (
    <>
      <Sidebar />
      <main className="content">
        <Navbar />
        <div className="py-4 d-flex justify-content-between align-items-center">
          <div>
            <h1 className="h4 mb-1">Login Devices</h1>
            <p className="mb-0 text-muted">Active admin dashboard sessions</p>
          </div>
          <button className="btn btn-secondary" type="button" onClick={fetchDevices}>
            Refresh
          </button>
        </div>

        <div className="card border-0 shadow">
          <div className="card-body">
            {loading ? (
              <p className="mb-0">Loading...</p>
            ) : devices.length === 0 ? (
              <p className="mb-0">No login devices found.</p>
            ) : (
              <div className="table-responsive">
                <table className="table table-hover align-middle">
                  <thead>
                    <tr>
                      <th>Admin</th>
                      <th>IP</th>
                      <th>Device</th>
                      <th>Login Time</th>
                      <th>Last Seen</th>
                      <th>Status</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {devices.map((device) => (
                      <tr key={device._id}>
                        <td>
                          <strong>{device.adminName || "Admin"}</strong>
                          <div className="small text-muted">{device.adminEmail}</div>
                        </td>
                        <td>{device.ip || "-"}</td>
                        <td className="text-break" style={{ maxWidth: 360 ,whiteSpace: "break-spaces"}}>
                          {device.userAgent || "-"}
                        </td>
                        <td>{formatDate(device.loginAt)}</td>
                        <td>{formatDate(device.lastSeenAt)}</td>
                        <td>
                          <span className={`badge ${device.isCurrent ? "bg-success" : "bg-secondary"}`}>
                            {device.isCurrent ? "Current" : "Active"}
                          </span>
                        </td>
                        <td>
                          <button className="btn btn-sm btn-outline-danger" type="button" onClick={() => removeDevice(device)}>
                            Logout
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
          </div>
        </div>
      </main>
    </>
  );
};

export default LoginDevices;
